import styled from 'styled-components'
import ClockIcon from '../../../images/icons/clock.svg'
import {Product, ProductItem, ProductType} from 'types/rest'
import {formatDuration} from '../../../helpers/formatDuration'
import React, {PropsWithChildren, useEffect, useState} from 'react'
import {getLanguage} from '@store/selectors'
import {useSelector} from 'react-redux'
import useMediaQuery from '../../../hooks/useMediaQuery'
import {small} from '../../../constants'
import useRest from '../../../hooks/useRest'
import {logger} from "@helpers";

const InfoContentMobile: React.FC<PropsWithChildren<Props>> = ({
  data,
  purchased,
  masterclass,
  product,
  children
}) => {
  const language = useSelector(getLanguage)
  const isMobile = useMediaQuery(`(max-width: ${small})`)
  // const navigate = useNavigate()

  const [products, setProducts] = useState<{ data: string | null; products: Product[] | null }[]>([
    { data: null, products: null }
  ])
  const { get } = useRest<Product>('products')

  useEffect(() => {
    if (data?.authors.length < products.length) return

    data.authors?.forEach((author) => {
      get({ filters: { withItems: true } })
        .then((res) => {
          const updatedProd = products
          updatedProd.push({ data: `${author.name} ${author.surname}`, products: res.payload.filter((prod: Product)=> prod.authors.find(aut => aut.id === author.id) && data?.id !== prod?.id )})
          setProducts(updatedProd)
        })
        .catch((e) => logger.error(e))
    })
  }, [data.authors, get, products, data?.id])

    /*const isPodcast = useCallback((item: any) => {
        if ((item.type as ProductType)?.label) {
            return (item.type as ProductType).label === 'podcast'
        }
        return item.type === 'podcast'
    }, [])*/

  return (
    data && (
      <Container isMobile={isMobile}>
        <InfoContainer purchased={purchased} masterclass={masterclass} isMobile={isMobile}>
          <Info>
              <div>
                  {data?.translations[language]?.surtitle && <p style={{fontSize: isMobile ? 'var(--button-body-mobile)' : 'var(--surtitle-item)', margin: isMobile ? '1rem 0' : '0'}}>
                      {data.translations && data.translations[language].surtitle}
                  </p>}
                  <p style={{fontSize: isMobile ? 'var(--title-h2-mobile)' : 'var(--title-h2)', fontWeight: 'bold',  margin: isMobile ? '1rem 0' : '0'}}>
                      {data.translations && data.translations[language].title}
                  </p>
                  <p style={{fontSize: isMobile ? 'var(--button-body-mobile)' : 'var(--surtitle-item)', margin: isMobile ? '1rem 0' : '0'}}>
                      {data.translations && data.translations[language].subtitle}
                  </p>
              </div>
          </Info>
          <InfoR>
              {
                  data && (data?.type as ProductType)?.label !== 'course' && (<FastInfo>
                      <img src={ClockIcon} style={{ marginRight: '10px' }} alt="" />
                      {`${formatDuration(
                          'productItems' in data ? data?.duration : (data as ProductItem).video?.duration || 0
                      )}`}
                  </FastInfo>
                  )
              }
          </InfoR>
          {children}
        </InfoContainer>
       {/* <Content>
          <SplideContainer>
            <Splide
              style={{ width: '100%', height: '100%' }}
              aria-label="My Favorite Images"
              options={{
                arrows: false,
                perPage: 1,
                padding: '20px',
                interval: 3000,
                gap: '1rem',
                pagination: false,
                overfloX: 'hidden'
              }}>
              {data?.authors &&
                data.authors.map((item, k) => (
                  <SplideSlide
                    style={{ display: 'flex', justifyContent: 'center', width: ' 100%', height: '100%' }}
                    key={k}>
                    <Card>
                      <Avatar
                        style={{
                          aspectRatio: '2/1',
                          width: '10rem',
                          height: '10rem',
                          borderRadius: '10px',
                          overflow: 'hidden'
                        }}>
                        <img style={{ objectFit: 'cover' }} src={`${conf.baseUrl}${item.avatar}`} alt="" />
                      </Avatar>
                      <div
                        onClick={() => navigate(`/authors/${item.slug || item.id}`)}
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          fontSize: '1.6rem',
                          fontWeight: 600
                        }}>{`${item.name} ${item.surname}`}</div>
                    </Card>
                  </SplideSlide>
                ))}
            </Splide>
          </SplideContainer>
          <ReletedProducts>
            {products.map(
              (item) =>
                item.products && (
                  <ProductsSlider<Product>
                    key={item.data}
                    title={`${translation.PAGES.courses.moreOf} ${item.data}`}
                    data={item.products}
                    CardComponent={ProductCard}
                    style={{ margin: '3rem 0' }}
                  />
                )
            )}
          </ReletedProducts>
        </Content>*/}
          <Description isMobile={isMobile}>{data.translations[language].description}</Description>
        <Hr></Hr>
      </Container>
    )
  )
}

export default InfoContentMobile

interface Props {
  openMenu?: () => void
  data: Product | ProductItem
  detail?: boolean
  isMenuOpen?: boolean
  purchased?: boolean
  product?: Product
  masterclass?: boolean
}

const Container = styled.div<{ isMobile: boolean }>`
  width: 100%;
`

const InfoContainer = styled.div<{ masterclass?: boolean; purchased?: boolean; isMobile: boolean }>`
  /* margin: ${(props) => (props.isMobile ? '' : '80px')} 0; */
  display: grid;
  grid-template-columns: 6fr 1fr;
  gap: 0.5rem;
  padding: 0 20px;
  height: fit-content;
  border-bottom: 1px solid #707070;
`

const Info = styled.div`
  display: flex;
  align-items: center;
`
const InfoR = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const FastInfo = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`
/*
const Content = styled.div`
  width: 100%;
  margin: 3rem 0;
`

const Card = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  width: 100%;
  gap: 2rem;
  height: 10rem;
`
*/

const Hr = styled.div`
  width: 96%;
  margin: 0 auto;
`

/*const SplideContainer = styled.div`
  overflow-x: hidden;
  width: 100%;
`

const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  height: 10rem;
  width: auto;
  & img {
    flex-shrink: 0;
    min-width: 100%;
    max-height: 100%;
  }
`*/

const Description = styled.div<{isMobile?: boolean}>`
  padding: 2rem 20px;
  font-size: ${({isMobile}) => isMobile ? 'var(--parag-body-fs-mobile)' : 'var(--big-parag-fs)'};
  white-space: pre-wrap;
`

/*
const ReletedProducts = styled.div`
  margin: 3rem 0;
  width: 100%;
`
*/
